import { DotsLoader } from './DotsLoader'
import { SpinnerLoader } from './SpinnerLoader'

export * from './DotsLoader'
export * from './SpinnerLoader'

const Loader = {
  Dots: DotsLoader,
  Spinner: SpinnerLoader,
}
export { Loader }
